import { WriteProjectLimit } from "@/types/projectLimit";

interface Values {
  hours: string;
  rate: string;
  addition: string;
}

export const createLimitsForStoresBasedOnValues = (
  monthString: string,
  storeIds: string[],
  entityId: string,
  values: Values,
): WriteProjectLimit => ({
  period: monthString,
  stores: storeIds.map((storeId) => ({
    store_id: storeId,
    limits: [
      {
        dependency_id: entityId,
        hours: values.hours.toString(),
        rate: values.rate.toString(),
        addition: values.addition.toString(),
      },
    ],
  })),
});
